export const BACK_TO_SYSTEM_DASHBOARD = 'Dashboard';
export const BACK_TO_SYSTEM_ADMIN = 'ManageUserAccounts';

const AccountManagementConstants = {
  BACK_TO_SYSTEM_DASHBOARD,
  BACK_TO_SYSTEM_ADMIN
};

export default AccountManagementConstants;